import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da292152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "current-language" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "symbol symbol-20px me-4" }
const _hoisted_6 = ["src"]

import { ref, onMounted, computed } from "vue";
import { useI18n } from "vue-i18n";
import { ILanguage, LanguageTypes } from "@/core/types/LanguageTypes";
import { getTenantLanguagesOptions } from "@/core/types/TenantTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageDropdown',
  setup(__props) {

const i18n = useI18n();
let countries: ILanguage[];
countries = getTenantLanguagesOptions.value;
const showDropdownLang = ref(false);

// eslint-disable-next-line @typescript-eslint/no-empty-function
onMounted(async () => {});

const setLang = (language: string) => {
  showDropdownLang.value = !showDropdownLang.value;
  i18n.locale.value = language;
  localStorage.setItem("language", language);
};

const currentLanguage = (language: string) => {
  return i18n.locale.value === language;
};

const currentLanguageLocale = computed(() => {
  return (
    countries.find((x) => x.code === i18n.locale.value) ?? LanguageTypes.enUS
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: {"position":"relative"},
    class: "menu-gray-600",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (showDropdownLang.value = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (showDropdownLang.value = false))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("img", {
        class: "w-25px h-25px rounded-1 ms-2",
        src: currentLanguageLocale.value.flag,
        alt: "BCR Pro",
        style: {"margin-right":"8px"}
      }, null, 8, _hoisted_2),
      _createTextVNode(" " + _toDisplayString(currentLanguageLocale.value.name), 1)
    ]),
    _hoisted_3,
    (showDropdownLang.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (showDropdownLang.value = false)),
          class: "menu-dropdown"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (lang, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menu-item px-3 language-item",
              key: index
            }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (setLang(lang.code)),
                href: "#",
                class: _normalizeClass(["menu-link d-flex px-5", { active: currentLanguage(lang.code) }])
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("img", {
                    class: "rounded-1",
                    src: lang.flag,
                    alt: "BCR Pro"
                  }, null, 8, _hoisted_6)
                ]),
                _createTextVNode(" " + _toDisplayString(lang.name ?? "Name"), 1)
              ], 10, _hoisted_4)
            ]))
          }), 128))
        ], 32))
      : _createCommentVNode("", true)
  ], 32))
}
}

})